import React from 'react'
import { Grid } from '@mui/material'
import EMobilityWallboxCard from './EMobilityWallboxCard'
import { WallboxHardwareModel } from 'src/Libs/wallboxes/models'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Alert } from '@e3dc-react/shell/Elements/Alert'

interface EMobilityWallboxCardsProps {
  wallboxes: WallboxHardwareModel[]
  isDynamicPrice: boolean
}

const EMobilityWallboxCards: React.FC<EMobilityWallboxCardsProps> = ({ wallboxes, isDynamicPrice }): JSX.Element => {
  const { t } = useCustomTranslation()

  return (
    <Grid container spacing={3} py={3}>
      {wallboxes.length > 0 ? (
        wallboxes.map((wallbox, index) => (
          <Grid item xs={12} sm={6} md={6} xl={4} key={`item - ${index}`}>
            <EMobilityWallboxCard
              isDynamicPrice={isDynamicPrice}
              wallboxId={wallbox.wallboxId}
              title={wallbox.deviceName}
              storageId={wallbox.storageSerialNumber.toString()}
              wallboxIndex={wallbox.number}
              wallboxType={wallbox.wallboxType}
              wallboxes={wallboxes}
            />
          </Grid>
        ))
      ) : (
        <Grid item xs={12}>
          <Alert variant="filled" severity="info" text={t('emobility.wallbox.no-wallboxes-alert')} />
        </Grid>
      )}
    </Grid>
  )
}

export default EMobilityWallboxCards
